// extracted by mini-css-extract-plugin
module.exports = {"main":"MainRoutes_main__Tfxs8","scrollable":"MainRoutes_scrollable__1tvcp"};